import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

const usePolling = (interval = 300000) => {
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const onBehalf = JSON.parse(localStorage.getItem('onBehalfName'));
                const userInfo = JSON.parse(localStorage.getItem('userInfo'));
                const org_id = userInfo?.org_id || null;
                const user_id = userInfo?.id || null;
                await dispatch.AppNotifications.getAppNotifications({ user_id, onBehalf, org_id });
            } catch (err) {
                console.error('Polling error:', err);
            }
        };

        fetchData();
        const intervalId = setInterval(fetchData, interval);
        return () => clearInterval(intervalId);
    }, [interval, dispatch]);
};

export default usePolling;